import React from 'react';

const CSS = `
  @keyframes tabPop { 0%{transform:scale(0.85)} 60%{transform:scale(1.1)} 100%{transform:scale(1)} }
  .bnav-item { transition: all 0.2s ease; cursor: pointer; }
  .bnav-item:active { transform: scale(0.93); }
`;

const C = { gold: '#F0B429', bg: '#080810', card: '#0f0f1a', border: 'rgba(255,255,255,0.07)' };

export default function BottomNav({ tabs, active, onChange }) {
  const isNative = !!(window.Capacitor && window.Capacitor.isNative);
  // En nativo: subimos la barra 50px para que el banner AdMob quede visible encima
  const bottomOffset = isNative ? 50 : 0;

  return (
    <>
      <style>{CSS}</style>
      <div style={{
        position: 'fixed',
        bottom: bottomOffset,
        left: 0,
        right: 0,
        width: '100%',
        maxWidth: 480,
        margin: '0 auto',
        background: 'rgba(10,10,20,0.97)',
        borderTop: `1px solid ${C.border}`,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        display: 'flex',
        zIndex: 1000,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}>
        {tabs.map(tab => {
          const isActive = tab.id === active;
          return (
            <button
              key={tab.id}
              className="bnav-item"
              onClick={() => onChange(tab.id)}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 4px',
                background: 'none',
                border: 'none',
                outline: 'none',
                position: 'relative',
              }}
            >
              {isActive && (
                <div style={{
                  position: 'absolute',
                  top: 0, left: '25%', right: '25%',
                  height: 2,
                  background: C.gold,
                  borderRadius: '0 0 4px 4px',
                }} />
              )}
              <div style={{
                fontSize: 22,
                marginBottom: 3,
                filter: isActive ? 'drop-shadow(0 0 6px rgba(240,180,41,0.6))' : 'none',
                animation: isActive ? 'tabPop 0.3s ease' : 'none',
                transition: 'filter 0.2s',
              }}>
                {tab.icon}
              </div>
              <div style={{
                fontFamily: "'Oswald', sans-serif",
                fontSize: 9,
                letterSpacing: 1,
                color: isActive ? C.gold : '#4B4B5B',
                fontWeight: isActive ? 600 : 400,
                transition: 'color 0.2s',
                textTransform: 'uppercase',
              }}>
                {tab.label}
              </div>
            </button>
          );
        })}
      </div>
    </>
  );
}